import { Injectable } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import assign from 'lodash-es/assign';

declare var google: any;

@Injectable()
export class GooglePlacesService {
  autocompleteService: any;
  placeService: any;
  autocompleteOptions = {
    componentRestrictions: {country: 'us'},
    language: 'en',
    types: ['address']
  };
  predictions: Array<Object>;
  formattedAddress: string;

  constructor(private mapsAPILoader: MapsAPILoader) {}

  initService() {
    this.mapsAPILoader.load().then(() => {
      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.placeService = new google.maps.places.PlacesService(document.createElement('location'));
    });
    this.predictions = [];
  }

  getPredictions(input: Object) {
    let options = assign({}, this.autocompleteOptions, input);
    this.autocompleteService.getPredictions(options, (predictions: any) => {
      this.predictions = predictions;
    });
  }

  getPlaceDetails(place_id: string) {
    this.placeService.getDetails({ placeId: place_id }, (place: any) => {
      this.formattedAddress = place.formatted_address;
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/google_places.ts